import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter, FaSync } from "react-icons/fa";
import Toast from "./Toast";

const menu1 = [
  {
    title: "⁠The Book",
    path: "/the-book",
  },
  {
    title: "The Film",
    path: "/the-film",
  },
  {
    title: "⁠Awards",
    path: "/awards",
  },
  {
    title: "Fun/Trivia",
    path: "/fun-trivia",
  }
];

const menu2 = [
  {
    title: "About Author",
    path: "/about",
  },
  {
    title: "Contact",
    path: "/contact",
  }
];

const generateCaptcha = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let code = "";
    for (let i = 0; i < 6; i++) code += chars[Math.floor(Math.random() * chars.length)];
    return code;
};

const Footer = () => {
    const [email, setEmail] = useState("");
    const [toast, setToast] = useState(null);
    const [loading, setLoading] = useState(false);
    const [step, setStep] = useState("email");
    const [captcha, setCaptcha] = useState("");
    const [captchaInput, setCaptchaInput] = useState("");
    const captchaInputRef = useRef(null);
    const submittingRef = useRef(false);

    const closeToast = useCallback(() => setToast(null), []);

    const showToast = (type, message) => {
        setToast({ type, message, id: Date.now() });
    };

    const showCaptcha = () => {
        setCaptcha(generateCaptcha());
        setCaptchaInput("");
        setStep("captcha");
    };

    const refreshCaptcha = () => {
        setCaptcha(generateCaptcha());
        setCaptchaInput("");
    };

    const submitNewsletter = async () => {
        if (submittingRef.current) return;
        submittingRef.current = true;
        setLoading(true);

        try {
            await axios.post("/api/newsletter", { email: email.trim() });
            setEmail("");
            setCaptchaInput("");
            setStep("email");
            showToast("success", "You're subscribed. Thank you!");
        } catch (err) {
            showToast("error", "Unable to subscribe. Please try again.");
        }

        setLoading(false);
        submittingRef.current = false;
    };

    useEffect(() => {
        if (step === "captcha") captchaInputRef.current?.focus();
    }, [step]);

    const handleSubscribe = (e) => {
        e.preventDefault();

        if (step === "captcha") {
            if (captchaInput !== captcha) {
                showToast("error", "Captcha does not match!");
                return;
            }
            submitNewsletter();
            return;
        }

        if (!email.trim()) {
            showToast("error", "Please enter a valid email.");
            return;
        }

        showCaptcha();
    };

    const handleCaptchaChange = (value) => {
        setCaptchaInput(value);
        if (value === captcha) submitNewsletter();
    };

    return(
        <>
        <footer className="py-16 bg-brand-dark">
            <div className="page-width">
                <div className="footer_inner">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        <div className="footer_logo_wrapper">
                            <Link to="/">
                                <img src="/Images/logo.png" alt=" Ghosted MD logo" width="570" height="59" className="h-10 md:mx-0" />
                            </Link>
                            <p>SOMETIMES A CASE IS WORTH SOLVING — EVEN IN DEATH</p>
                        </div>
                        <div className="footer_menu_block">
                            <h3 className="footer_link_title">Quick Links</h3>
                            {menu1.map((link, index) =>
                                <Link
                                    key={index}
                                    to={link.path}
                                    className="footer_link inline"
                                >
                                    {link.title}
                                </Link>
                            )}
                        </div>
                        <div className="footer_menu_block">
                            <h3 className="footer_link_title">Customer service</h3>
                            {menu2.map((link, index) =>
                                <Link
                                    key={index}
                                    to={link.path}
                                    className="footer_link inline"
                                >
                                    {link.title}
                                </Link>
                            )}
                        </div>
                        <div className="social_media_wrapper">
                            <form className="footer_newsletter" onSubmit={handleSubscribe}>
                                <h3 className="footer_link_title">Get News, Updates & Offers</h3>
                                {step === "captcha" ? (
                                    <>
                                        <div className="footer_newsletter_captcha_row">
                                            <div className="footer_newsletter_captcha_code" aria-hidden="true">
                                                {captcha}
                                            </div>
                                            <button
                                                type="button"
                                                onClick={refreshCaptcha}
                                                className="footer_newsletter_captcha_refresh"
                                                aria-label="Refresh captcha"
                                                disabled={loading}
                                            >
                                                <FaSync />
                                            </button>
                                        </div>
                                        <input
                                            ref={captchaInputRef}
                                            type="text"
                                            name="captcha"
                                            value={captchaInput}
                                            onChange={(e) => handleCaptchaChange(e.target.value)}
                                            placeholder="Enter captcha"
                                            required
                                            autoComplete="off"
                                            disabled={loading}
                                            className="footer_newsletter_input"
                                            aria-label="Enter captcha"
                                        />
                                    </>
                                ) : (
                                    <>
                                        <input
                                            type="email"
                                            name="email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            placeholder="Email"
                                            required
                                            className="footer_newsletter_input"
                                            aria-label="Email"
                                        />
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="footer_newsletter_button"
                                        >
                                            {loading ? "Subscribing..." : "Subscribe"}
                                        </button>
                                    </>
                                )}
                            </form>
                            <h3 className="footer_link_title">Let's Connect</h3>
                            <div className="text-white social_media_inner_wrapper flex gap-4">
                                <a href="https://www.facebook.com/NafsikasGarden/" target="_blank" rel="noreferrer" aria-label="Facebook">
                                    <FaFacebookF size={20} />
                                </a>
                                <a href="https://www.instagram.com/nafsikasgarden/" target="_blank" rel="noreferrer" aria-label="Instagram">
                                    <FaInstagram size={20} />
                                </a>
                                <a href="https://www.youtube.com/@nafsikaantypas" target="_blank" rel="noreferrer" aria-label="YouTube">
                                    <FaYoutube size={20} />
                                </a>
                                <a href="https://x.com/nafsikasgarden" target="_blank" rel="noreferrer" aria-label="X">
                                    <FaTwitter size={20} />
                                </a>
                            </div>
                            <div className="downloadable_links_wrapper flex gap-4 mt-8">
                                <a rel="noreferrer" href="https://play.google.com/store/apps/details?id=com.plant.based.food&pli=1" target="_blank">
                                    <img src="/Images/googleplay.webp" alt="Download on Google Play" width="280" height="83" loading="lazy" decoding="async" />
                                </a>
                                <a rel="noreferrer" href="https://apps.apple.com/in/app/the-plant-based-switch/id6444078958" target="_blank">
                                    <img src="/Images/appstore.webp" alt="Download on the App Store" width="280" height="83" loading="lazy" decoding="async" />
                                </a>  
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        {toast && (
            <Toast
                key={toast.id}
                type={toast.type}
                message={toast.message}
                onClose={closeToast}
            />
        )}
        </>
    );
}

export default Footer;
